import React, { useEffect, useRef, useState } from 'react'
import ActionArea from '../../../components/ActionArea'
import SelectInput from '../../../components/UI/SelectInput'
import SmartSearch from '../../../components/UI/SmartSearch'
import SwitchInput from '../../../components/UI/SwitchInput'
import { IParams } from '../../../context/ListRecordProvider/types'
import { getRealTimeTransactionLog } from '../../../services/reports'
import ReportParser from '../../../components/ReportParser'
import { useLoading } from '../../../context/LoadingProvider/useLoading'
import Container from "../../../components/Container";
import Box from "../../../components/Box";
import { sendSystemLog } from '../../../context/AuthProvider/useAuth'

const autoRefreshTimeOptions = [
  {name: '05 minutes', value: 5},
  {name: '10 minutes', value: 10},
  {name: '30 minutes', value: 30},
  {name: '1 hour', value: 60}
]

const REFRESH_TIME =  10 * 1000

function RealTimeTransactionLog() {
  const loading = useLoading()
  const [params, setParams] = useState<IParams>({
    id: null,
    name: '',
    type: '',
  })
  const [search, setSearch] = useState('')
  const [validSearch, setValidSearch] = useState(false)
  const [refresh, setRefresh] = useState({
    time: 5,
    autoRefresh: true
  })
  const ref = useRef<any | null>(null)
  const [report, setReport] = useState('')
  const log = {
    log_type: 'visited',
    log_object: 'rt_transaction_log'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])

  useEffect(() => {
    if(refresh.autoRefresh) {
      ref.current = setInterval(refreshReport, REFRESH_TIME);
    }
    if(!refresh.autoRefresh) {
     if(ref.current) clearInterval(ref.current)
    }
    
    return () => {
      if(ref.current){
        clearInterval(ref.current)
      }
    }
  }, [refresh, params])

  const refreshReport = async (addLoading?: boolean) => {
	if(validSearch) {
	    if(addLoading) loading.addLoading()
	    const res =  await getRealTimeTransactionLog({
	        locationId: params.id,
	        timeRange: refresh.time,
	        output: 'html',
            date: new Date()
	      })
	      setReport(res)
	    loading.removeLoading()
	}
  }

  return (
    <div className="report-view-page">
      <ActionArea disabled={!validSearch} buttonAction={() => refreshReport(true)} buttonText='Refresh'>
        <>
          <SmartSearch
              label="Smart Search"
              searchBy={['location']}
              onChange={(e: string) => setSearch(e)}
              value={search}
              status="active"
              onValidSearch={setValidSearch}
              onObjValueChange={(e: any) => setParams({...params, ...e})}
              autoFocus
          />
          <SelectInput
              label='Time Range'
              options={autoRefreshTimeOptions}
              value={refresh.time}
              onSelectChange={(e) => setRefresh({...refresh, time: e?.value ? e.value : e})}
          />
          <SwitchInput
              onChange={(e) => setRefresh({...refresh, autoRefresh: e})}
              value={refresh.autoRefresh}
              options={{check: true, uncheck: false,}}
              label="Auto Refresh"
          />
        </>

      </ActionArea>

      <Container>

        <ReportParser html={report}/>
      </Container>

    </div>
  )
}

export default RealTimeTransactionLog